/** When signers section is hidden (UY), signer validation must not block save/continue. */
export function resolveSignersHasErrors(
  isUruguayEnabled: boolean,
  hasErrors: boolean
): boolean {
  const signersSectionActive = !isUruguayEnabled;
  return signersSectionActive ? hasErrors : false;
}
